import { ChangesDoctorTemplate } from "../../templates/ChangesDoctorTemplate/ChangesDoctorTemplate";

export const ChangesDoctorPage = () => {
  return <ChangesDoctorTemplate />;
};
